import styles from "./ContactCard.module.scss";
import WhatsAppIcon from "@Icons/WhatsAppIcon";
import EnvelopeIcon from "@Icons/EnvelopeIcon";
import PhoneIcon from "@Icons/PhoneIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { PAGE } from "constants/configConstants";
import WechatGreenOutline from "@Icons/WechatGreenOutline";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useCustomWindowOpen from "@Components/CustomWindowOpen";
import AmberCopilotLogo from "@Icons/AmberCopilotLogo";
import BoltIcon from "@Icons/BoltIcon";
//

const Borders: any = {
  liveChat: styles.liveChatBorder,
  whatsapp: styles.whatsappBorder,
  email: styles.plainBorder,
  phone: styles.plainBorder,
  weChat: styles.whatsappBorder,
};

const BgColors: any = {
  liveChat: styles.liveChatBgColor,
  whatsapp: styles.whatsappBgColor,
  weChat: styles.whatsappBgColor,
};

const TagTexts: any = {
  liveChat: "profile.support.components.supportlistitem.instantreply",
  whatsapp: "home.contactus.twominreply",
  weChat: "home.herosection.24hrsassistance",
};

const triggerEvents = (
  iconKey: string,
  href: string,
  handleZendeskCB?: () => void,
  customWindowOpen?: any,
) => {
  if (iconKey == "liveChat" && handleZendeskCB) {
    handleZendeskCB();
  }
  gtagEventEmitter({
    action: "need_help_card_clicked",
    category: PAGE.HOME,
    iconKey,
  });
  if (href && customWindowOpen) {
    customWindowOpen({ url: href, target: "_blank", isExternal: true });
  }
};

const ContactCard = ({
  label,
  iconKey,
  showTag = false,
  href = "",
  isDesktop = false,
  handleZendeskCB = null,
}: any) => {
  const customWindowOpen = useCustomWindowOpen();
  const { t } = useTranslationHook();
  const Icons: any = {
    liveChat: <AmberCopilotLogo height={isDesktop ? 36 : 22} width={isDesktop ? 36 : 22} />,
    whatsapp: (
      <WhatsAppIcon
        height={isDesktop ? "36" : "22"}
        width={isDesktop ? "36" : "22"}
        fill="#25D366"
      />
    ),
    email: <EnvelopeIcon height={isDesktop ? 36 : 22} width={isDesktop ? 36 : 22} fill="#E3A008" />,
    phone: <PhoneIcon height={isDesktop ? 36 : 22} width={isDesktop ? 36 : 22} fill="#3F83F8" />,
    weChat: <WechatGreenOutline height={isDesktop ? 36 : 22} width={isDesktop ? 36 : 22} />,
  };
  return (
    <span
      role="none"
      className={styles.contactCardAnchor}
      onClick={() => triggerEvents(iconKey, href, handleZendeskCB, customWindowOpen)}
    >
      <div
        className={formatClassNames(
          styles.contactCardInner,
          Borders[iconKey],
          isDesktop && styles.desktop,
        )}
        data-testid={`homepage-needhelp-${label}`}
      >
        <button
          type="button"
          className={styles.symbolButton}
          data-testid={`homePage-${label}-button`}
        >
          {Icons[iconKey]}
        </button>
        <div className={styles.contactCardLabel}>{t(label)}</div>
        {showTag && (
          <div className={formatClassNames(styles.quickReplyTag, BgColors[iconKey])}>
            {iconKey === "liveChat" ? <BoltIcon /> : <span className={styles.whiteDot} />}
            <span className={styles.quickReplyTagText}>{t(TagTexts[iconKey])}</span>
          </div>
        )}
      </div>
    </span>
  );
};

export default wrapperHOC(ContactCard, {
  componentName: "ContactCard-GetHelpDesktop-Home",
  showForChina: true,
});
